import { CombinedFilter } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { OrderDetailAttributes } from '@albatrosdeveloper/ave-models-package';
import { map, tap } from 'rxjs';
import get from 'lodash-es/get';
import { OrderCustomerService } from 'app/modules/components/reports/historic/order-customer/order-customer.service';
import { ExportStoreService } from '../../../export-overlay.store';
import { ExportFileFormat, ExportRange } from '../../core/export-task.enum';
import { LegacyExportTask } from '../../core/export-task-legacy';

/** This class is instantiated by a factory (see ExportService).
 * The base ExportTask class takes care of all the functionality of the
 * task, like the current page, the progress and the status of the
 * task. */
export class OrderCustomerExport extends LegacyExportTask {
  constructor(
    itemCount: number,
    initialFilter: CombinedFilter<OrderDetailAttributes>,
    range: ExportRange,
    format: ExportFileFormat,
    store: ExportStoreService,
    private orderCustomerService: OrderCustomerService,
    exportId: string = 'order-customer',
    title: string = 'Histórico de Pedidos'
  ) {
    super(exportId, title, itemCount, range, format, initialFilter, store);
  }

  private transformObject(item: OrderDetailAttributes) {
    return {
      subRoute: get(item, 'subRoute.name', '??'),
      user: get(item, 'user', '??'),
      serials: get(item, 'serials', '??'),
      date: get(item, 'date', '??'),
      shipToName: get(item, 'shipToName', '??'),
      materialName: get(item, 'materialName.name', '??'),
      baseUnitOfMeasureCode: `${get(item, 'baseUnitOfMeasure.code', '??')} ${get(item, 'baseUnitOfMeasure.name', '??')}`,
      unitPrice: get(item, 'unitPrice', '??'),
      subTotal: get(item, 'subTotal', '??'),
      total: get(item, 'total', '??'),
    };
  }

  /** Better header text for excel and csv */
  private transformObjectAsNatural(item: OrderDetailAttributes) {
    return {
      Ruta: get(item, 'subRoute.name', '??'),
      Usuario: get(item, 'user', '??'),
      ['Nro Doc']: get(item, 'serials', '??'),
      Fecha: get(item, 'date', '??'),
      Cliente: get(item, 'shipToName', '??'),
      Material: get(item, 'materialName.name', '??'),
      UM: `${get(item, 'baseUnitOfMeasure.code', '??')} ${get(item, 'baseUnitOfMeasure.name', '??')}`,
      Precio: get(item, 'unitPrice', '??'),
      Subtotal: get(item, 'subTotal', '??'),
      Total: get(item, 'total', '??'),
    };
  }

  /** The main method of the export task class. Called for each page. Here do the request, process
   * and transform the data. The result for each request after processed must be an object array,
   * this object array will be later transformed to a file (xlsx, csv, json) automatically. */
  override onRequest(currentFilter: CombinedFilter<OrderDetailAttributes>) {
    // To avoid displaying the global loading screen, the header x-ave-ctx is sent with the request,
    // the http interceptor finds that the header is set as 'export' and ignores the request, so
    // won't display the loading screen.
    return this.orderCustomerService.findByFilter(currentFilter, { contextHeader: 'export' }).pipe(
      tap((response) => {
        if (this.format === ExportFileFormat.JSON) {
          this.addToSection(
            'Histórico de Pedidos',
            get(response, 'data.0.data', []).map((item) => this.transformObject(item))
          );
        }
        this.addToSection(
          'Histórico de Pedidos',
          get(response, 'data.0.data', []).map((item) => this.transformObjectAsNatural(item))
        );
      }),
    );
  }
}
